import { SyntheticEvent } from 'react';

import { NavLink } from 'react-router-dom';

import { Box, SxProps, Theme } from '@mui/material';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { AppTypography } from '~components/ui/typography/app-typography';

import { useActiveScope } from '~hooks/use-active-scope';

type Props = {
  label: string;
  icon?: React.FC | null;
  to: string;
  sx?: SxProps<Theme>;
  activeColor?: string;
  inactiveColor?: string;
  activeBackgroundColor?: string;
  hoverBackgroundColor?: string;
  onClick?: (event: SyntheticEvent) => void;
};

export const SidebarItem = ({
  label,
  icon,
  to,
  onClick,
  sx,
  activeColor = 'primaryTokens.100',
  inactiveColor = 'fog.40',
  activeBackgroundColor = 'primaryTokens.10',
  hoverBackgroundColor = 'fog.95',
}: Props) => {
  const scope = useActiveScope();

  return (
    <NavLink
      to={to}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      style={{ textDecoration: 'none' }}
      end={scope === 'tenant'}
    >
      {({ isActive }) => (
        <Box
          display="flex"
          alignItems="center"
          px={2}
          py={1}
          borderRadius={1}
          gap={1.25}
          sx={{
            color: isActive ? activeColor : inactiveColor,
            backgroundColor: isActive ? activeBackgroundColor : 'transparent',
            '&:hover': {
              backgroundColor: hoverBackgroundColor,
            },

            ...sx,
          }}
        >
          {icon && (
            <Box
              component="span"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <AppIcon component={icon} size={22} />
            </Box>
          )}
          <AppTypography
            size="body-md"
            weight="bold"
            color={isActive ? activeColor : inactiveColor}
          >
            {label}
          </AppTypography>
        </Box>
      )}
    </NavLink>
  );
};
